import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AssessmentIcon from './images/pencil.svg';
import ResourceIcon from './images/article.svg';
import SeriesIcon from './images/graduation.svg';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: '24px',
    gap: '16px',
    [theme.breakpoints.down('600')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    flex: 1,
  },
  iconWrapper: {
    marginBottom: '24px',
    [theme.breakpoints.down('600')]: {
      marginBottom: '12px',
    },
  },

  text: {
    color: '#000',
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: '20px',
    paragraphSpacing: '8px',
    fontFamily: theme.typography.fontFamily,
  },
}));

export default function EmbeddedRedirectContent({ customLabels }) {
  const classes = useStyles();
  const { infoLabel1, infoLabel2, infoLabel3 } = customLabels;
  return (
    <Box className={classes.container}>
      <Box className={classes.section}>
        <Box className={classes.iconWrapper}>
          <img src={ResourceIcon} alt="Resource" className={classes.icon} />
        </Box>
        <Typography className={classes.text}>{infoLabel1}</Typography>
      </Box>

      <Box className={classes.section}>
        <Box className={classes.iconWrapper}>
          <img src={AssessmentIcon} alt="Assessment" className={classes.icon} />
        </Box>
        <Typography className={classes.text}>{infoLabel2}</Typography>
      </Box>

      <Box className={classes.section}>
        <Box className={classes.iconWrapper}>
          <img src={SeriesIcon} alt="Series" className={classes.icon} />
        </Box>
        <Typography className={classes.text}>{infoLabel3}</Typography>
      </Box>
    </Box>
  );
}
